// These are meant as custom tracking events for 3rd party systems
// for page views and user identification there are default events in most systems

// add only common events here - special use cases can go into IBE or Component-Lib

enum TrackingEvent {
  PRODUCT_LIST_VIEW = 'PRODUCT_LIST_VIEW',
  PRODUCT_EXACT_LIST_VIEW = 'PRODUCT_EXACT_LIST_VIEW',
  PRODUCT_DETAIL_VIEW = 'PRODUCT_DETAIL_VIEW',
  PRODUCT_SELECT_ITEM = 'PRODUCT_SELECT_ITEM',
  CART_INIT = 'CART_INIT',
  CART_VIEW = 'CART_VIEW',
  CART_ITEM_ADDED = 'CART_ITEM_ADDED',
  CART_ITEM_REMOVED = 'CART_ITEM_REMOVED',
  CART_HOTEL_UPGRADE = 'CART_HOTEL_UPGRADE',
  CART_CLEARED = 'CART_CLEARED',
  INSURANCE_ADDED = 'INSURANCE_ADDED',
  CHECKOUT_START = 'CART_CHECKOUT_START',
  CHECKOUT_FINISH = 'CART_CHECKOUT_FINISH',
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT'
}

export default TrackingEvent;
